import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-center',
  templateUrl: './privacy-center.component.html',
  styleUrls: ['./privacy-center.component.scss']
})
export class PrivacyCenterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
